<div class="row">
  <div class="col-sm-12">
    <section class="panel">
      <app-page-title title="Edit StatusCategory" [loading]="isLoading"></app-page-title>

      <div class="panel-body">
        <form class="form-horizontal" (ngSubmit)="edit()" ngNativeValidate>
          <app-status-category-form [statusCategory]="statusCategory" *ngIf="statusCategory"></app-status-category-form>
        </form>
      </div>
    </section>
  </div>
</div>
